import { UserDocumentStatusResponse } from 'types/user-documents';
import { USERS_DOCUMENTS } from 'utils/constants/end-points';
import Http from './http';

class UserDocumentsService {
	getDocumentStatus = (): Promise<UserDocumentStatusResponse> => Http.get(`${USERS_DOCUMENTS}/status`);
}

export default new UserDocumentsService();
